import { Box, Flex } from 'dash-ui';
import styled from 'styled-components';

import { stickyTopBarStyles } from 'containers/properties/helpers/stickyTopBarStyles';

export const StyledBox = styled(Box)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.n20};
`;

export const TopBarWrapper = styled(Flex)<{ top?: number }>`
  ${stickyTopBarStyles}
`;
